(function (angular, schoolwork12) {
    
    'use strict';
    angular.module(schoolwork12.app.student.name)

    .factory(schoolwork12.app.student.services.studentUnlockCurriculum, 
        ['$rootScope', '$http', '$uibModal', '$q', schoolwork12.app.auth.services.authentication,
        function($rootScope, $http, $uibModal, $q, authentication) {      

  		var service  = function unlockCurriculumModal(selectedStudents, selectedStudentsCount) {
			var modalInstance = $uibModal.open({
			    templateUrl: schoolwork12.app.student.templates.studentUnlockCurriculum,
			    size: 'md',
			    backdrop: 'static',
			    windowClass: 'medium-Modal',
			    controller: ['$scope', '$uibModalInstance',			   
		        function ($scope, $uibModalInstance) {
		       		console.log("Viewing Unlock Curriculum for Students");
				
			    //initialize default settings
			    $scope.UnlockCurriculumErrorMesg = "";
			    $scope.UnlockCurriculumErrorOccurred = false;
			    $scope.UnLockCurriculumErrorAuthorizedByMesg = "";
			    $scope.UnLockCurriculumErrorAuthorizedBy = false;			    
			    $scope.UnLockCurriculumErrorCommentsMesg = "";
			    $scope.UnLockCurriculumErrorComments = false;		    
			    $scope.isSaveStudentUnlockCurriculumBusy = false;			    
				$scope.studentsCount = selectedStudentsCount;
				$scope.unlockCurriculum = {};
				$scope.UnlockCurriculumForm = false;
				$scope.UnlockCurriculumButtonAction = true;
			   
				$scope.cancel = function () {
				    $uibModalInstance.dismiss('cancel');
				};

				$scope.closeErrorMsg = function() {
                    $scope.UnlockCurriculumErrorOccurred = false; 
                }  

				$scope.studentUnlockCurriculum = function(){
					resetErrorFlags();
					$scope.isSaveStudentUnlockCurriculumBusy = true;

                    if ($scope.isFormValid()) {
                    	$scope.UnlockCurriculumForm = true;

                    	$http({
			              	url : schoolwork12.app.student.endpoints.studentCurriculumLock,
			              	method : "POST",
			              	data : {								    
								    authorizedBy: $scope.unlockCurriculum.authorizedBy,
								    otherReason: $scope.unlockCurriculum.comments,
								    students:selectedStudents, 
								    unlock: true
									},
		        		  	headers : {
										'X-API-TOKEN' : authentication.getCurrentUser().keycode,
									}
			              	}).success(function (response) {
			              		console.info("Students locked successfully", response);
	            	   			$scope.UnlockCurriculumErrorOccurred = false;
	            	   			$rootScope.actionCompletedSuccessfully = true;
	            	   			$rootScope.actionCompletedSuccessfullyMessage = "You have successfully unlocked your student(s)'s curriculum."			              		
			              		$uibModalInstance.close();
			              	}).error(function(error, status){ 
			              		$scope.UnlockCurriculumErrorOccurred = true;
			              		$scope.UnlockCurriculumButtonAction = false;
			                	console.info('Error in locking students...'.concat(angular.toJson(error)));
			                	if (status == 400) {
									for ( var j = 0; j < error.data._errors.length; j++) {
										$scope.UnlockCurriculumErrorMesg = schoolwork12.app.student.modalErrMessages.unlockStudentsFailed + error.data._errors[j] + "\n";
									}
								} else if (status == 401 || status == 403) {
			                        $scope.UnlockCurriculumErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
			                    } else {
			                        $scope.UnlockCurriculumErrorMesg = schoolwork12.app.student.modalErrMessages.unlockStudentsFailed + " " +schoolwork12.app.errorMessages.internalError;
			                    }
			            	});

                    } else {
                    	$scope.isSaveStudentUnlockCurriculumBusy = false;
                    	$scope.UnlockCurriculumForm = false;
                    }
				}

				$scope.isFormValid = function(){

					console.info("Validating unlockCurriculum authorizedBy");
					if ($scope.unlockCurriculum.authorizedBy == null ||
					    $scope.unlockCurriculum.authorizedBy== "") {
						$scope.UnLockCurriculumErrorAuthorizedBy = true;
						$scope.UnLockCurriculumErrorAuthorizedByMesg = schoolwork12.app.student.errorMessages.unlockAuthorizedByRequired 
					}					

					console.info("Validating unlockCurriculum comment");
					if ($scope.unlockCurriculum.comments == null ||
					    $scope.unlockCurriculum.comments== "") {
						$scope.UnLockCurriculumErrorComments = true;
						$scope.UnLockCurriculumErrorCommentsMesg = schoolwork12.app.student.errorMessages.unlockCommentRequired 
						
					}

					return !$scope.UnLockCurriculumErrorComments && !$scope.UnLockCurriculumErrorAuthorizedBy

				}

				
                           	
				var resetErrorFlags = function() {
                    // Control Error messages 
                    $scope.UnlockCurriculumErrorMesg = "";
                    $scope.UnlockCurriculumErrorOccurred = false; 
                    $scope.UnLockCurriculumErrorAuthorizedByMesg = "";
                    $scope.UnLockCurriculumErrorAuthorizedBy = false;  
                    $scope.UnLockCurriculumErrorCommentsMesg = "";
                    $scope.UnLockCurriculumErrorComments = false;     
                    $rootScope.actionCompletedSuccessfully = false;
	            	$rootScope.actionCompletedSuccessfullyMessage = "";              
                }

			}],
		  	    
		});

	};

    return {
    	service: service
    };

}]);
    
}(angular, schoolwork12));